export default "__VITE_ASSET__FL9vwG5i__"